import { ComponentRef, Directive, ElementRef, EmbeddedViewRef, inject, ViewContainerRef } from '@angular/core';
import { _AbcTooltipComponent } from './abc-tooltip/abc-tooltip.component';

@Directive({
  selector: '[abcTooltip]',
  standalone: true,
})
export class AbcTooltipDirective {
  private tooltipComponent: ComponentRef<_AbcTooltipComponent>;
  private viewContainerRef: ViewContainerRef = inject(ViewContainerRef);
  public elementClassName: string;

  public toolTipContentTemplate: string;
  constructor(private elementRef: ElementRef<HTMLElement>) {
    const el: HTMLElement = this.elementRef.nativeElement;
    el?.addEventListener('mouseenter', (event) => {
      this.createAbcTooltipComponent(this.elementRef);
      this.onMouseEnter();
    });
  }

  private createAbcTooltipComponent(elementRef: ElementRef) {
    if (!this.tooltipComponent) {
      this.tooltipComponent = this.viewContainerRef?.createComponent(_AbcTooltipComponent);
      const domElement = (this.tooltipComponent.hostView as EmbeddedViewRef<any>).rootNodes[0] as HTMLElement;
      elementRef.nativeElement.appendChild(domElement);
    }
    return this.tooltipComponent;
  }

  private onMouseEnter() {
    const tooltip = <_AbcTooltipComponent>this.tooltipComponent?.instance;
    const element = this.elementRef?.nativeElement.querySelectorAll(this.elementClassName)[0];
    this.showOrHideTooltip(element, tooltip);
  }

  private showOrHideTooltip(el, tooltip: _AbcTooltipComponent): void {
    el?.addEventListener('mouseenter', (event) => {
      const target = event.target as Element;
      if (this.toolTipContentTemplate) {
        const target = event.target as Element;
        tooltip.contentTemplate = this.toolTipContentTemplate;
        tooltip.target = target;
        tooltip.visible = true;
      } else if (el.offsetWidth < el.scrollWidth) {
        if (!el.outerText?.trim()?.length) {
          tooltip.contentTemplate = el.value;
        } else {
          tooltip.contentTemplate = el.outerText;
        }
        tooltip.target = target;
        tooltip.visible = !!tooltip.contentTemplate;
      }
    });
    el?.addEventListener('mouseleave', () => {
      tooltip.visible = false;
    });
  }
}
